import React from "react";
import PropTypes from "prop-types";

import SmartGuideLine from "./SmartGuideLine";


export default function SmartGuidesOverlay({
  guides = [],
  className = "",
}) {
  return (
    <div
      className={[
        "studio-smart-guides-overlay",
        className,
      ].filter(Boolean).join(" ")}
      aria-hidden="true"
    >
      {guides.map((guide) => (
        <SmartGuideLine
          key={guide.id}
          guide={guide}
        />
      ))}
    </div>
  );
}


SmartGuidesOverlay.propTypes = {
  guides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      orientation: PropTypes.oneOf([
        "horizontal",
        "vertical",
      ]).isRequired,
      position: PropTypes.number.isRequired,
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
    }),
  ),
  className: PropTypes.string,
};
